import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import {FormGroup, FormBuilder, AbstractControl} from '@angular/forms';
import { DtoCustomerOrigin } from './models/DtoCustomerOrigin';
import { SettingsBaseService } from './settings-base.service';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { SharedService } from '../../shared/shared.service';
import { Observable } from 'rxjs/Rx';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";

@Component({
    selector: 'found-by',
    template: require('./found-by.component.html'),
    styles: [require('./found-by.component.css')]
})
@AutoUnsubscribe()

export class FoundByComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    form: FormGroup;
    dtoObject: DtoCustomerOrigin;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsBaseService,
                private ss: SharedService) { }

    ngOnInit() {
        this.form = this.fb.group({
            description: ['', [SharedValidators.customRequired]],
            index: [null,[SharedValidators.customRequired], [AsyncValidatorWrapper.debounce(this.validateIndex.bind(this))]],
            isActive: true
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );

        if (this.id > 0) {
            this.ds.getCustomerOriginById(this.id)
                .subscribe(response => {
                    this.dtoObject = response;
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
            });
        }
        else {
            this.ds.getCustomerOriginNextIndex()
                .subscribe(res => {
                    this.dtoObject = {
                        id: 0,
                        isActive: true,
                        index: res
                    };
                    if (this.copyFromId > 0) {
                        this.ds.getCustomerOriginById(this.copyFromId)
                            .subscribe(response => {
                                this.dtoObject.description = response.description;
                                this.dtoObject.isActive = response.isActive;
                                this.fs.patchDtoToForm(this.dtoObject, this.form);
                        });
                    }
                    else {
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    }
            });
        }
    }

    validateIndex(control: AbstractControl) {
        return Observable.create(observer => {
            if (this.dtoObject != null && control.dirty && control.value != null) {
                this.ds.checkCustomerOriginIndexAvailable(this.dtoObject.id, control.value)
                    .subscribe((response: boolean) => {
                        observer.next(response ? null : { indexNotAvailable: true });
                        observer.complete();
                        if (this.validationMessage) this.validationMessage.getFormValidationErrors();
                    });
            }
            else {
                observer.next(null);
                observer.complete();
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
        });
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            this.ds.saveCustomerOrigin(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.closeWindow(true);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
            });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-base/found-by.component.ts